export default __webpack_public_path__ + "static/media/step3.b7e9b625.png";